import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d9b5032")

_pushScopeId("data-v-1d9b5032")
const _hoisted_1 = /*#__PURE__*/_createVNode("path", {
  "stroke-width": "0.3",
  "shape-rendering": "crispEdges",
  d: "M 16 0 L 0 0 L 0 16 L 4 16 L 4 4 L 16 4 L 16 0 Z"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "image-clip-handler",
    style: _ctx.clipWrapperPositionStyle
  }, [
    _createVNode("img", {
      class: "bottom-img",
      src: _ctx.src,
      draggable: false,
      alt: "",
      style: _ctx.bottomImgPositionStyle
    }, null, 12, ["src"]),
    _createVNode("div", {
      class: "top-image-content",
      style: {
        ..._ctx.topImgWrapperPositionStyle,
        clipPath: _ctx.clipPath,
      }
    }, [
      _createVNode("img", {
        class: "top-img",
        src: _ctx.src,
        draggable: false,
        alt: "",
        style: _ctx.topImgPositionStyle
      }, null, 12, ["src"])
    ], 4),
    _createVNode("div", {
      class: "operate",
      style: _ctx.topImgWrapperPositionStyle,
      onMousedown: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.moveClipRange($event), ["stop"]))
    }, [
      (_openBlock(), _createBlock(_Fragment, null, _renderList(['t-l', 't-r', 'b-l', 'b-r'], (point) => {
        return _createVNode("div", {
          class: ['clip-point', point],
          key: point,
          onMousedown: _withModifiers($event => _ctx.scaleClipRange($event, point), ["stop"])
        }, [
          _createVNode(_component_SvgWrapper, {
            width: "16",
            height: "16",
            fill: "#fff",
            stroke: "#333"
          }, {
            default: _withId(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ], 42, ["onMousedown"])
      }), 64))
    ], 36)
  ], 4)), [
    [_directive_click_outside, _ctx.handleClip]
  ])
})